import React from 'react';
import { Grid, Fab, List, Button, TextField, Divider } from '@material-ui/core';
import { ReactComponent as TrashAltSolid } from './Icoane Font Awesome/trash-alt-solid.svg'
import WsC from './providers/WsC'

export default class ListGrupaje extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subIntrebari: [],
            loading: true
        }
    }

    componentDidMount() {
        this.getSubIntrebari()
    }


    ws = new WsC()

    getSubIntrebari = async () => {


        let ws = new WsC()

        let getSubIntrebari = await ws.customSelect('select * from chestionare_intrebari where id_parent = @p1 and isnull(inactiv,0) != 1', {
            p1: this.props.intrebareParent.id
        })

        if (getSubIntrebari.Succes) {
            // console.warn('getSubIntrebari', getSubIntrebari)

            let cloneIntrebari = [...getSubIntrebari.Content]

            let idUriIntrebari = new Set(cloneIntrebari.map(i => i.id))

            idUriIntrebari = [...idUriIntrebari]

            if (idUriIntrebari.length > 0) {
                let raspunsuri = await ws.customSelect(`select * from chestionare_intrebari_optiuni_raspuns where isnull(inactiv,0) != 1 and id_intrebare in (${idUriIntrebari}) order by id asc`, {
                    p1: 1
                })

                if (raspunsuri.Succes) {
                    //    console.warn('raspunsuri subintrebari :', raspunsuri);


                    for (let i = 0, n = cloneIntrebari.length; i < n; i++) {

                        //   console.warn('enter looop')
                        let raspunsuriClone = raspunsuri.Content.filter(r => r.id_intrebare === cloneIntrebari[i].id)
                        //   console.warn('raspunsuri clone =-====', raspunsuriClone)
                        cloneIntrebari[i].raspunsuri = raspunsuriClone

                    }

                    // console.warn('cloneIntrebari :', cloneIntrebari);
                    this.setState({ subIntrebari: cloneIntrebari })
                }
            }

        }
    }


    intrebareChange = (ev, r) => {

        // console.log('ev :', ev.target.value);
        // console.log('r :', r);

        let subIntrebari = [...this.state.subIntrebari]

        let idx = subIntrebari.findIndex(s => s.id === r.id_intrebare)

        if (idx !== -1) {
            let idxR = subIntrebari[idx].raspunsuri.findIndex(rasp => rasp.id === r.id)

            if (idxR !== -1) {
                subIntrebari[idx].raspunsuri[idxR].label = ev.target.value

                this.setState({ subIntrebari: subIntrebari })
            }
        }


    }

    updateRaspuns = async (r) => {
        //   console.log('raspuns :', r);

        let ws = new WsC()

        let update = await ws.update('chestionare_intrebari_optiuni_raspuns', { label: r.label }, { id: r.id })

        if (update.Succes) {
            //  console.log('succesUpdate :', );
        }
    }

    titluIntrebareChange = (ev, i) => {
        console.log('ev.target.value :>> ', ev.target.value);
        console.log('i :>> ', i);

        let subI = [...this.state.subIntrebari]

        let val = ev.target.value

        let idx = subI.findIndex(s => s.id === i.id)


        if (idx !== -1) {
            subI[idx]['intrebare'] = val

            this.setState({ subIntrebari: subI })

        }
    }

    updateSubintrebare = async (i) => {
        console.log('i :>> ', i);



        let update = this.ws.update('chestionare_intrebari', { intrebare: i.intrebare }, { id: i.id })


        if (update.Succes) {
            //  console.log('succesUpdate :', );

        }
    }



    render() {
        return (
            <div>
                <Grid container style={{ borderRadius: 16, position: 'relative', padding: 10 }}>

                    {/* <div>
                        <Fab style={{ position: 'absolute', top: 6, right: 10 }} onClick={this.props.addRow} className="chestionare-adauga-button">
                            <i className='material-icons chestionare-anuleaza-button-icon'>add</i>
                        </Fab>
                    </div> */}

                    <Divider className='chestionare-divider' />
                    <List className="chestionare-common-list">
                        {
                            this.state.subIntrebari.map((i, idx) => {
                                return (
                                    <div key={idx}>


                                        <div style={{ textAlign: 'right', position: 'relative', marginTop: 10 }}>

                                            <TrashAltSolid onClick={() => { this.props.deleteRaspuns(i) }} className='textSecondary iconSvg' style={{ marginRight: 0, width: 24, height: 24, marginTop: 10 }} />



                                            <div style={{ textAlign: 'left' }}>
                                                <span className='textPrimary' style={{
                                                    marginRight: 5,
                                                    fontSize: 17,
                                                    fontWeight: 600,
                                                    verticalAlign: 'bottom'
                                                }}>{idx + 1}.</span>

                                                <div style={{ position: 'relative', display: 'inline', width: '100%' }}>
                                                    <input

                                                        style={{
                                                            width: '90%',
                                                            textAlign: 'left',
                                                            color: 'rgba(0, 0, 0, 0.87)',
                                                            textOverflow: 'ellipsis',
                                                            lineHeight: 1,

                                                            margin: 0,
                                                            fontSize: 15,
                                                            fontFamily: 'inherit',
                                                            verticalAlign: 'text-top',

                                                            padding: 10
                                                        }}
                                                        id={`raspunse${i.id}`}

                                                        className='add-project-input'
                                                        type='text'
                                                        name='label'
                                                        value={i.intrebare}
                                                        onChange={(ev) => { this.titluIntrebareChange(ev, i) }}
                                                        onBlur={() => { this.updateSubintrebare(i) }} />
                                                    <label className='inputLabelPM' htmlFor={`raspuns${i.id}`}>Titlu Subintrebare</label>
                                                </div>

                                            
                                            </div>


                                            <Grid container style={{ justifyContent: 'center', width: '95%' }}>

                                                {i.raspunsuri.map((r, idx2) => {
                                                    return (
                                                        <Grid style={{ marginTop: 20 }} key={`raspuns${idx2}`} item xs={6} sm={6} md={6} lg={6} xl={6}>

                                                            <div style={{ position: 'relative', display: 'inline', width: '100%' }}>
                                                                <input

                                                                    style={{
                                                                        width: '90%',
                                                                        textAlign: 'left',
                                                                        color: 'rgba(0, 0, 0, 0.87)',
                                                                        textOverflow: 'ellipsis',
                                                                        lineHeight: 1,

                                                                        margin: 0,
                                                                        fontSize: 15,
                                                                        fontFamily: 'inherit',
                                                                        verticalAlign: 'text-top',

                                                                        padding: 10
                                                                    }}
                                                                    id={`raspunse${r.id}`}

                                                                    className='add-project-input'
                                                                    type='text'
                                                                    name='label'
                                                                    value={r.label}
                                                                    onChange={(ev) => { this.intrebareChange(ev, r) }}
                                                                    onBlur={() => { this.updateRaspuns(r) }} />
                                                                <label className='inputLabelPM' htmlFor={`raspuns${r.id}`}>Varianta raspuns {idx2 + 1}</label>
                                                            </div>




                                                        </Grid>

                                                    )
                                                })}

                                            </Grid>



                                            {/* <i onClick={() => { this.props.deleteRaspuns(i) }} className='material-icons iconFontSize textSecondary' >delete</i> */}

                                            <div style={{ textAlign: 'left', marginBottom: 10, marginTop: 10 }}>

                                 

                                             <Button style={{ width: 'fit-content', marginBottom: 20, marginLeft: 15 }} variant="contained" onClick={() => { this.props.addCell(i) }} className='chestionare-adauga-raspuns-button'>
                                        {/* <i className='material-icons'>add_circle_outline</i>   */}
                                                Adauga raspuns
                                             </Button>

                                            </div>
                                        </div>


                                        <Divider className="crm-divider" />

                                    </div>

                                )
                            })
                        }

                        <div style={{ padding: 10 }}>
                            <Fab style={{ backgroundColor: '#00c0f4', color:'white' }} onClick={this.props.addRow} >
                                <i className='material-icons textWhite'>add_circle_outline</i>
                            </Fab>
                        </div>

                    </List>

                </Grid>

            </div>
        );
    }
}